import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsUpcScan } from 'react-icons/bs';

import './SupportingDocumentMultipleButton.scss';
import { useWorkReportModals } from '../../../context/WorkReportModalsContext';

const SupportingDocumentMultipleButton = (props) => {
  const { data, monthly, disabled, onAction, setNewFetch, selectedDate, maxDate, minDate } = props;
  const { activeSupportingDocumentModal } = useWorkReportModals();

  const onPressButton = () => {
    if (disabled) {
      return;
    }
    if (onAction) {
      onAction(data);
    }

    activeSupportingDocumentModal({
      data: {
        idPartetrabajo: data?.idPartetrabajo,
        idSolicitud: data?.idSolicitud,
        ubicacionStr: data?.ubicacionStr
      },
      isMultiple: true,
      monthly,
      selectedDate,
      maxDate,
      minDate,
      updateLineData: () => setNewFetch((val) => !val)
    });
  };

  return (
    <OverlayTrigger
      delay={{
        show: 250,
        hide: 400
      }}
      overlay={
        <Tooltip id="supporting-document-tooltip">
          Carga masiva de Identificador de Documento de Respaldo
        </Tooltip>
      }
      placement="top"
    >
      <button
        className="supporting_document_multiple"
        disabled={disabled}
        onClick={onPressButton}
        type="button"
      >
        <span style={{ color: disabled ? '#bbbbbb' : '#159AD8' }}>
          <BsUpcScan color={disabled ? '#bbbbbb' : '#159AD8'} />
          {' Id Doc. Respaldo'}
        </span>
      </button>
    </OverlayTrigger>
  );
};

SupportingDocumentMultipleButton.propTypes = {
  data: PropTypes.shape({
    idPartetrabajo: PropTypes.number,
    idSolicitud: PropTypes.number,
    ubicacionStr: PropTypes.string
  }),
  setNewFetch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  onAction: PropTypes.func,
  monthly: PropTypes.bool,
  selectedDate: PropTypes.string,
  maxDate: PropTypes.string,
  minDate: PropTypes.string
};

SupportingDocumentMultipleButton.defaultProps = {
  data: {},
  disabled: false,
  onAction: () => {},
  monthly: false,
  selectedDate: null,
  maxDate: null,
  minDate: null
};

export default SupportingDocumentMultipleButton;
